<div id="turnSelector" class="pb-2 w-full text-1.25 flex justify-start items-center">
  <div class="font-semibold text-center ism-gold pr-2">Turn Selector:</div>
  <button type="button" class="btn btn-default" (click)="prevMonth()" [disabled]="(editTurn() || 1)<=firstTurn()">
    <!-- Previous -->
    <ism-svg [name]="'minus'" [classString]="'w-6 h-6 flex items-center text-yellow-300 hover:text-white visited:text-yellow-300'"></ism-svg>
  </button>
  @if (editTurn() === firstTurn()) {
  Startup Turn
  }
  @else if (editTurn() > firstTurn()) {
  {{" Edit turn: " + editTurn() + "  "}}
  }
  <button type="button" class="btn btn-default" (click)="nextMonth()" [disabled]="(editTurn() || 1)>=(maxTurn() || 6)">
    <!-- Next -->
    <ism-svg [name]="'plus'" [classString]="'w-6 h-6 flex items-center text-yellow-300 hover:text-white visited:text-yellow-300'"></ism-svg>
  </button>
</div>
